import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useTranslations } from "../../../providers/useTranslations";
import styles from "./Label.module.scss";
export const Label = ({ label, labelId, checkable, labelCaption, required, id, showRequiredAsterisk = true, labelClassName, }) => {
    const { __ } = useTranslations();
    if (!label)
        return null;
    const requiredSign = showRequiredAsterisk ? "*" : "";
    const requiredText = required ? requiredSign : __("form_fields.optional");
    const extendedLabelText = !checkable ? requiredText : "";
    return (_jsxs("label", { id: labelId, className: classNames(styles.label, labelClassName), htmlFor: id, children: [_jsxs("div", { children: [label, " ", extendedLabelText] }), labelCaption && _jsx("div", { className: styles.labelCaption, children: labelCaption })] }));
};
//# sourceMappingURL=Label.js.map